import { Injectable } from '@angular/core';

@Injectable()
export class SIDENAV_DATA {
  data: any = {};
}
